import { render, staticRenderFns } from "./TribeId.vue?vue&type=template&id=1fcc9c58&scoped=true&"
import script from "./TribeId.vue?vue&type=script&lang=js&"
export * from "./TribeId.vue?vue&type=script&lang=js&"
import style0 from "./TribeId.vue?vue&type=style&index=0&id=1fcc9c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc9c58",
  null
  
)

export default component.exports